export default __webpack_public_path__ + "static/media/Image (2).5d7b3533.png";